<template>
  <div>
    <MyBreadcrumb
      :breadcrumb-list="[
        {text:'工作台',to:'/'},
        {text:'我的应用',to:''}
      ]"
    ></MyBreadcrumb>

    <div class="wrap-box">
      <div class="wrap-left">
        <div class="nav-item select">
          我的应用
        </div>
        <div
          class="nav-item"
          @click="goOrderRecord"
        >
          订购记录
        </div>
      </div>
      <div class="wrap-right">
        <!-- 数据未加载出来时显示骨架屏 -->
        <skeleton v-if="tablePage.loading"></skeleton>
        <MyTablePage
          v-else
          ref="myTablePage"
          v-model="tablePage.params"
          class="myTablePage"
          :load-data="tablePage.on.loadData"
          :data="tablePage.data"
          :total="tablePage.total"
          :columns="tablePage.columns"
          :form-items="tablePage.formItems"
          :label-width="70"
          :autoload="false"
          :show-page="true"
        >
        </MyTablePage>
      </div>
    </div>
    <!-- 授权弹框 -->
    <Modal
      v-model="authModal.visiable"
      :closable="false"
      :footer-hide="true"
      :width="460"
    >
      <div
        class="authModal-box"
      >
        <div v-if="authModal.authValue">
          <div>
            <Icon
              type="ios-checkmark-circle"
              class="authModal-icon"
              :size="30"
              color="#5E7CE0"
            />
            <span>应用授权成功</span>
          </div>
          <div class="authModal-tip">
            恭喜您授权成功，如果你对应用权限有疑问，你可以取消授权
          </div>
        </div>
        <div v-else>
          <div>
            <Icon
              type="ios-close-circle-outline"
              style="vertical-align: middle; margin-right: 5px;"
              :size="30"
            />
            <span>应用已关闭授权</span>
          </div>
          <div class="authModal-tip">
            你的店铺已关闭授权，如有需要请重新授权
          </div>
        </div>
        <div>
          <Button @click="authModal.on.close">
            我知道了
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import MyTablePage from '@/components/Template/TablePage';
import moment from 'moment';
import skeleton from './components/Skeleton';
export default {
  components: { MyTablePage,skeleton },
  data() {
    return {
      tablePage: {
        loading: true,
        data: [],
        total: 0,
        columns: [
          {
            title: '应用名称',
            key: 'saleName',
            align: 'center',
            width: 260,
            render: (h,params)=>{
              const {productImage,saleName,productCode,productType} = params.row;
              const html = [];
              const img = h('img',{
                style: {
                  width: '66px',
                  height: '44px',
                  verticalAlign: 'middle',
                  marginRight: '5px',
                  flexShrink: 0,
                },
                attrs: {
                  src: productImage,
                },
              });
              html.push(img);
              const span = h('span',saleName);
              html.push(span);
              return h(
                'div',
                {
                  style: 'display:flex;align-items: center;padding:20px 0;cursor:pointer',
                  on: {
                    click: ()=>{
                      let path = '/app/appDetail/index';
                      if (productType===1){
                        // productType: 2, // 1 产品 2应用
                        path = '/standardProduct/productVersion/index';
                      }
                      this.$router.push({
                        path,
                        query: {
                          productCode,
                        },
                      });
                    },
                  },
                },
                html,
              );
            },
          },
          // {
          //   title: '订单编号',
          //   key: 'orderNo',
          //   align: 'center',
          // },
          {
            title: '有效期',
            key: 'serviceEnd',
            align: 'center',
            width: 170,
            render: (h,params)=>{
              const {serviceEnd,serviceStart} = params.row;
              const html = [];
              html.push(h('div',serviceStart));
              html.push(h('div',serviceEnd));
              return html;
            },
          },
          {
            title: '订购店铺',
            key: 'accountNo',
            align: 'center',
            width: 200,
            render: (h,params)=>{
              const {orderSourceDesc,accountNo,accountName} = params.row;
              const html = [];
              html.push(h('span',accountName || orderSourceDesc));
              html.push(h('span',`(${accountNo})`));
              return html;
            },
          },
          {
            title: '应用授权',
            key: 'orderTime',
            align: 'center',
            render: (h,params)=>{
              const html = [];
              const {buyRecordId,authStatus,_index} = params.row;
              const authStatusDesc = authStatus===3 ? '关闭授权':'开启授权';
              html.push(
                h(
                  'i-switch',
                  {
                    props: {
                      value: ![1,5].includes(authStatus),
                      'before-change': ()=>{
                        return new Promise(resolev=>{
                          this.$Modal.confirm({
                            title: `${authStatusDesc}！`,
                            content: `是否${authStatusDesc}？`,
                            onOk: () => {
                              const url = '/paycenter-charge/api/worktable/auth';
                              this.$http.post(
                                url,
                                {
                                  authStatus: authStatus===3 ? 5:3,
                                  buyRecordId,
                                }).then(res => {
                                if (res.success) {
                                  resolev();
                                  // this.$refs.myTablePage.getList(1);
                                  this.$refs.myTablePage.rows[_index].authStatus = authStatus===3 ? 5:3;

                                  // this.$Message.success('授权成功');
                                } else {
                                  this.$Message.warning(res.message || '授权失败');
                                }
                              });
                            },
                          });

                        });
                      },
                    },
                    on: {
                      'on-change': (value)=>{
                        this.authModal.on.show(value);
                      },
                    },
                  },
                ),
              );
              return html;
            },
          },
          {
            title: '操作',
            key: 'period',
            align: 'center',
            render: (h,params)=>{
              const {productCode,buyerId,accountNo,productSkuId,buyRecordId} = params.row;
              const style = {
                marginRight: '10px',
                color: '#409EFF',
                cursor: 'pointer',
              };
              // 详情
              const detailSpanPrps = {
                style,
                on: {
                  click: ()=>{
                    const url = '/paycenter-charge/api/worktable/goShop';
                    const params1 = {productCode,buyerId};
                    this.$http.get(url,params1).then(res=>{
                      if (res.success){
                        // window.location.href = res.data;
                        if (res.data){
                          // window.open(res.data,'_blank');
                          window.location.href = res.data;
                        } else {
                          this.$Message.warning('未配置服务入口');
                        }

                      } else {
                        this.$Message.warning(res.message||'获取数据失败');
                      }
                    });

                  },
                },
              };
              // 续费
              const renew = {
                style,
                on: {
                  click: ()=>{
                    this.$router.push({
                      path: '/app/order/index',
                      query: {
                        orderType: 3,// 1购买 3续费
                        type: 'renew',
                        productCode,
                        accountNo,
                        buyRecordId,
                        // orderNo,
                        // productCode,
                        // corpCode,
                        // corpName,
                        skuId: productSkuId,
                      },
                    });
                  },
                },
              };
              return (
                <div>
                  <span {...detailSpanPrps}>进入应用</span>
                  <span {...renew}>续费</span>
                </div>
              );
            },
          },
        ],
        // formItems: [
        //   {
        //     label: '订购状态',
        //     prop: 'orderStatus',
        //     type: 'select',
        //     placeholder: '请选择订购状态',
        //     data: ()=>{
        //       return this.$store.dispatch('getOrderStatus');
        //     },
        //     // on: {
        //     //   'on-change': (value) => {
        //     //     if (value) {
        //     //       this.search(1);
        //     //     }
        //     //   },
        //     // },
        //   },
        //   {
        //     label: '订购日期',
        //     prop: 'startTime',
        //     type: 'date',
        //     placeholder: '请选择开始时间',
        //     format: 'yyyy-MM-dd',
        //     options: {
        //       disabledDate: date => {
        //         let disabled = false;
        //         const { endTime } = this.tablePage.params;
        //         if (endTime) {
        //           if (date.getTime() > new Date(`${endTime} 23:59:59`).getTime()) {
        //             // 结束日期不得小于开始日期
        //             disabled = true;
        //           } else if (date.getTime() < new Date(endTime).getTime() - 30 * 24 * 60 * 60 * 1000) {
        //             // 结束日期与开始日期相差不超过30天
        //             disabled = true;
        //           }
        //         }

        //         return disabled;
        //       },
        //     },
        //     on: {
        //       input: (date) => {
        //         if (!date) {
        //           this.tablePage.params.startTime = '';
        //           return;
        //         }
        //         this.tablePage.params.startTime = moment(date).format('YYYY-MM-DD');
        //       },
        //       // 'on-change': (date) => {
        //       //   this.tablePage.params.startTime = date;
        //       // },
        //     },
        //   },
        //   {
        //     prop: 'endTime',
        //     type: 'date',
        //     placeholder: '请选择结束时间',
        //     format: 'yyyy-MM-dd',
        //     options: {
        //       disabledDate: date => {
        //         let disabled = false;
        //         // 如果date 和开始日期相同， 且没有时分秒 时间戳加 24小时
        //         const { startTime } = this.tablePage.params;
        //         if (startTime) {
        //           const time = date.getTime();

        //           if (time < new Date(`${startTime} 00:00:00`).getTime()) {
        //             // 结束日期不得小于开始日期
        //             disabled = true;
        //           } else if (date.getTime() > new Date(startTime).getTime() + 30 * 24 * 60 * 60 * 1000) {
        //             // 结束日期与开始日期相差不超过30天
        //             disabled = true;
        //           }
        //         }
        //         return disabled;
        //       },
        //     },
        //     on: {
        //       input: (date) => {
        //         if (!date) {
        //           this.tablePage.params.endTime = '';
        //           return;
        //         }
        //         this.tablePage.params.endTime = moment(date).format('YYYY-MM-DD');
        //       },
        //       // 'on-change': (date) => {
        //       //   this.tablePage.params.endTime = date;
        //       // },
        //     },
        //   },
        // ],
        params: {
          limit: 10,
          page: 1,
          // orderSource: this.$route.query.orderSource||'101',
          // startTime: moment().format('YYYY-MM-DD'),
        },
        on: {
          loadData: (callback) => {
            // 检查是否认证
            const {corpList,token} = this.$store.state.user.userInfo;
            if (token && (!corpList||!corpList.length)){
              // 弹出去认证弹框
              this.$root.$emit('show-auth-modal');
              // this.tablePage.loading = false;
              // return;
            }
            // const {orderSource,corpCode,corpName} = this.$route.query;
            const {
              corpCode,
              corpName,
              orderSource,
            } = this.$store.state.user.userInfo;
            if (!corpCode){
              if (typeof callback === 'function'){
                callback({
                  success: false,
                  // message: '缺少主体',
                });
              } else {
                this.tablePage.loading = false;
              }
              return;
            }
            const url='/paycenter-charge/api/worktable/my/app';
            const params = {
              ...this.tablePage.params,
              orderSource,corpCode,corpName,
            };
            const {startTime,endTime} = params;
            if (startTime){
              params.startTime = moment(`${startTime} 00:00:00`).unix()*1000;
            }
            if (endTime){
              params.endTime = moment(`${endTime} 23:59:59`).unix()*1000;
            }
            // this.tablePage.loading = true;
            this.$http.get(url, this.common.utils.trim(params)).then(res => {
              let rows = [];
              if (res.success) {
                this.tablePage.loading = false;
                rows = res.data.map(ele => {
                  return ele;
                });
              }


              if (typeof callback === 'function'){
                const data = {
                  ...res,
                  data: {
                    rows,
                    total: res.total,
                  },
                };
                callback(data);
              } else {
                this.tablePage.data = rows;
                this.tablePage.total = res.total;
                if (!res.success){
                  this.$Message.warning(res.message||'请求失败');
                }
              }
            });
          },
        },
      },
      authModal: {
        visiable: false,
        authValue: false,
        on: {
          show: (authValue)=>{
            this.authModal.authValue = authValue;
            this.authModal.visiable = true;
          },
          close: ()=>{
            this.authModal.visiable = false;
          },
        },
      },
    };
  },
  created() {

    // 获取列表数据
    this.tablePage.on.loadData();

  },
  mounted(){
    // 头部主体变化事件绑定
    // 防止多次监听
    // this.$root.$off('on-corp-change');
    this.$root.$on('on-corp-change', () => {
      // 重新获取已订购的产品
      // this.tablePage.on.loadData();
      this.$refs.myTablePage.getList(1);
    });
  },
  beforeDestroy(){
    // 防止多次监听
    this.$root.$off('on-corp-change');
  },
  methods: {
    goOrderRecord(){
      this.$router.push('/app/orderRecord/index');
    },
  },
};
</script>

<style scoped lang="less">
.wrap-box {
  display: flex;
  .wrap-left {
    box-sizing: border-box;
    // flex-shrink: 0;
    width: 15%;
    background-color: #fff;
    padding: 20px;
    .nav-item {
      cursor: pointer;
      margin-bottom: 10px;
      padding: 5px 0;
      text-align: center;
      &.select {
        color: #fff;
        background-color: #5e7ce0;
      }
    }
  }
  .wrap-right {
    // flex-shrink: 0;
    width: 85%;
  }
}
.myTablePage {
  background-color: #fff;
  padding: 20px 40px;
}
.authModal-box {
  text-align: center;
  padding: 20px 0;
  .authModal-icon {
    vertical-align: middle;
    margin-right: 5px;
  }
  .authModal-tip {
    padding: 20px 0;
    color: #999;
  }
}
</style>
